// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { deviceId } from './Device';
import { deviceModelPhaseId } from './DeviceModelPhase';
import { z } from 'zod';
export const devicePhaseId = (z.number());
export const devicePhase = z.object({
    id: devicePhaseId,
    device_id: deviceId,
    phase_id: z.string(),
    label: z.string(),
    description: z.string().nullable(),
    sort_order: z.number(),
    transitions: z.unknown(),
    model_phase_id: deviceModelPhaseId.nullable(),
    is_active: z.boolean(),
    last_seen_at: z.date().nullable(),
    created_at: z.date(),
    updated_at: z.date(),
    guards: z.unknown(),
});
export const devicePhaseInitializer = z.object({
    id: devicePhaseId.optional(),
    device_id: deviceId,
    phase_id: z.string(),
    label: z.string(),
    description: z.string().optional().nullable(),
    sort_order: z.number(),
    transitions: z.unknown().optional(),
    model_phase_id: deviceModelPhaseId.optional().nullable(),
    is_active: z.boolean().optional(),
    last_seen_at: z.date().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    guards: z.unknown().optional(),
});
export const devicePhaseMutator = z.object({
    id: devicePhaseId.optional(),
    device_id: deviceId.optional(),
    phase_id: z.string().optional(),
    label: z.string().optional(),
    description: z.string().optional().nullable(),
    sort_order: z.number().optional(),
    transitions: z.unknown().optional(),
    model_phase_id: deviceModelPhaseId.optional().nullable(),
    is_active: z.boolean().optional(),
    last_seen_at: z.date().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    guards: z.unknown().optional(),
});
//# sourceMappingURL=DevicePhase.js.map